import IndicesRevisionController from './indices.revision.controller';

export default {
    template: require('./indices.revision.tpl.html'),
    controller: IndicesRevisionController
};
